export default class PlayerPlayInterval {
  constructor(tech, data, playUUID, autoplay, ads) {
    this._tech = tech;
    this._data = data;
    this._playUUID = playUUID;
    this._autoplay = autoplay;
    this._ads = ads;
    this._isSeeking = false;
    this._tick = 0;
    this._counter = 0;
    this._lastCurrentTime = 0;
    this._interval = 15;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  playUUID() {
    return this._playUUID;
  }

  autoplay(){
    return this._autoplay;
  }

  ads(){
    return this._ads;
  }

  isSeeking() {
    return this._isSeeking;
  }

  tick() {
    return this._tick;
  }

  counter() {
    return this._counter;
  }

  lastCurrentTime() {
    return this._lastCurrentTime;
  }

  currentTime() {
    return Math.floor(this.tech().currentTime());
  }

  duration() {
    return Math.floor(this.tech().duration());
  }

  interval() {
    return this._interval;
  }

  _getMediaAttribute() {
    const hls = this.tech().plugin().hlsObject();
    const dash = this.tech().plugin().dashObject();

    if (dash.hasDashObject()) return dash.getCurrentMediaAttribute();
    return hls.getCurrentMediaAttribute();
  }

  register() {
    this.bindTimeupdate();
    this.bindSeeking();
    this.bindSeeked();
  }

  bindTimeupdate() {
    this.tech().on('timeupdate', () => {
      if (this.isSeeking()) return;

      const currentTime = this.currentTime();
      const lastCurrentTime = this.lastCurrentTime();

      if (this.isPlaying(currentTime, lastCurrentTime)) {
        this._tick = this._tick + 1;
        this._lastCurrentTime = currentTime;
      }

      if (this.tick() === this.interval()) {
        this._tick = 0;
        this._counter = this._counter + 1;
        this.triggerEventPlay(this.currentTime(), this.counter() * this.interval());
      }
    });
  }

  bindSeeking() {
    this.tech().on('seeking', () => {
      this._isSeeking = true;
    })
  }

  bindSeeked() {
    this.tech().on('seeked', () => {
      this._lastCurrentTime = this.currentTime();
      this._isSeeking = false;
    })
  }

  isPlaying(currentTime, lastCurrentTime) {
    return Math.abs(currentTime - lastCurrentTime) === 1;
  }

  getPlaybackSpeed() {
    console.log(this.tech())
    const speed = this.tech()._plugin._instance.player_.playbackRate();
    switch(speed) {
      case 0.5:
        return "0.5";
      case 0.75:
        return "0.75"
      case 1:
        return "normal"
      case 1.25:
        return "1.25"
      case 1.5:
        return "1.5"
    }
  }

  triggerEventPlay(position, duration) {
    this.tech().trigger({
      type: 'vp-video-play',
      video_id: this.data().videoId(),
      play_uuid: this.playUUID(),
      position,
      duration,
      bandwidth: this._getMediaAttribute().bitrate,
      quality: this.tech().getQuality(),
      networkState: this.tech().networkState(),
      has_ad: this.ads().paramsPresent(),
      video_duration: this.data().videoDuration(),
      autoplay: this.autoplay(),
      videoSourceBitrate: this.tech().getVideoSourceBitrate(),
      videoSourceHeight: this.tech().getVideoSourceHeight(),
      videoSourceWidth: this.tech().getVideoSourceWidth(),
      playerHeight: this.tech().getPlayerHeight(),
      playerWidth: this.tech().getPlayerWidth(),
      playback_speed: this.getPlaybackSpeed(),
      subtitle:  this.tech().getActiveSubtitle()
    });
  }
}
